var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-table-item-value-image-container"},[(_vm.url != null)?_c('img',{staticClass:"image",attrs:{"src":_vm.url,"alt":"image"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }